export const CONFIG = {
    signal_interval: 60000
};
